import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const WeightActiveSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <path
      d="M22.0181 17.3C22.0181 11.6118 17.5413 7 12.0186 7C6.49582 7 2.01813 11.6118 2.01813 17.3"
      stroke="url(#paint0_linear-weight)"
      strokeWidth="2.86364"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.766 12.0976L12.9454 16.512"
      stroke="#E06065"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.853 18.2309C15.3904 18.2309 15.8154 17.7666 15.7141 17.2389C15.6716 17.0176 15.62 16.8035 15.5599 16.6503C15.0019 15.2273 13.7135 14.2309 12.2131 14.2309C10.7152 14.2309 9.42837 15.2239 8.86877 16.6431C8.80775 16.7978 8.75537 17.0146 8.71231 17.2385C8.61076 17.7663 9.03575 18.2309 9.57327 18.2309H14.853Z"
      fill="url(#paint1_linear-weight)"
    />
    <path
      d="M2 18H21.8377"
      stroke="url(#paint2_linear-weight)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear-weight"
        x1="-7.76465"
        y1="8.07136"
        x2="-4.12745"
        y2="24.0815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9FB1E1" />
        <stop offset="1" stopColor="#6679BF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear-weight"
        x1="6.78732"
        y1="15.482"
        x2="9.63834"
        y2="20.5695"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7D95A6" />
        <stop offset="1" stopColor="#2E3D49" />
      </linearGradient>
      <linearGradient
        id="paint2_linear-weight"
        x1="4.08677"
        y1="19.9546"
        x2="4.24911"
        y2="17.6942"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9FB1E1" />
        <stop offset="1" stopColor="#6679BF" />
      </linearGradient>
    </defs>
  </SvgWrapper>
)
